import { NewCountry } from '@susu/headless-commerce/libs/avo/avo'
import type { NewCountryValueType } from '@susu/headless-commerce/libs/avo/avo'

/**
 * Asserts that a string is a valid NewCountryValueType
 * @param value - The string to assert
 * @returns The value as NewCountryValueType if valid
 * @throws Error if the value is not a valid country code
 */
export function assertNewCountryValue(value: string): NewCountryValueType {
  const normalizedValue = value.toLowerCase()
  const validCountryCodes = Object.values(NewCountry)

  if (!validCountryCodes.includes(normalizedValue as NewCountryValueType)) {
    throw new Error(
      `Invalid country code: ${value}. Must be one of: ${validCountryCodes.join(', ')}`,
    )
  }

  return normalizedValue as NewCountryValueType
}
